import { Entity } from "../core/Entity";
import {
  StorageObjectEmbedded,
  StorageObjectPostPayload,
} from "../storage_object/types";

export type LayoutSourceMetadataPage = {
  index: number;
  width: number;
  height: number;
};

export type LayoutSourceMetadata = {
  documentType: "pdf" | "docx";
  numberOfPages: number;
  pages: LayoutSourceMetadataPage[];
};

export type LayoutSourceGetResponse = Entity<{
  metadata: LayoutSourceMetadata;
  storageObject: StorageObjectEmbedded;
}>;

export type LayoutSourceEmbedded = LayoutSourceGetResponse;

export type LayoutSourcePostPayload = {
  storageObject: StorageObjectPostPayload;
};

export const RESOURCE_PATH = "/layout_sources";
